import styled from 'styled-components'
import { fontWeights, fontSizes } from '@/styles'
import { createModal } from '@/components/modalize/mui'
import { CautionIcon } from '@/components/icons'

const Wrapper = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
`

const Topper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fcf5d7;
  height: 25vh;
  width: 100%;
`

const Main = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 20px;
  margin: 40px 0;
  max-width: 450px;
  line-height: 32px;
  padding: 0 5%;
`

const Title = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.large};
`

const SubTitle = styled.div`
  font-weight: ${fontWeights.medium};
`

const MobileWarningModal = () => {
  return (
    <Wrapper>
      <Topper>
        <CautionIcon />
      </Topper>
      <Main>
        <Title>The contract builder is only available on desktop.</Title>
        <SubTitle>
          For a better editing experience, please login on a desktop web browser to continue.
        </SubTitle>
      </Main>
    </Wrapper>
  )
}

export const showMobileWarning = createModal(MobileWarningModal, {
  width: 'auto',
  maxWidth: '767px',
  tabletFullscreen: true,
  alignSelf: 'flex-start',
  showBackground: false,
  disableOverflowMobile: true
})
